/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type { TelegramHomepageShortcutsControllerFindManyQueryResponse } from '../../types/TelegramHomepageShortcutsControllerFindMany.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramHomepageShortcutsFindMany } from '../../methods/telegramHomepageShortcutsFindMany.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramHomepageShortcutsFindManyQueryKey = () => [{ url: '/api/telegram/homepage-shortcuts' }] as const;

export type TelegramHomepageShortcutsFindManyQueryKey = ReturnType<typeof telegramHomepageShortcutsFindManyQueryKey>;

export function telegramHomepageShortcutsFindManyQueryOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = telegramHomepageShortcutsFindManyQueryKey();
  return queryOptions<
    TelegramHomepageShortcutsControllerFindManyQueryResponse,
    ResponseErrorConfig<Error>,
    TelegramHomepageShortcutsControllerFindManyQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramHomepageShortcutsFindMany(config);
    },
  });
}

/**
 * {@link /api/telegram/homepage-shortcuts}
 */
export function useTelegramHomepageShortcutsFindMany<
  TData = TelegramHomepageShortcutsControllerFindManyQueryResponse,
  TQueryData = TelegramHomepageShortcutsControllerFindManyQueryResponse,
  TQueryKey extends QueryKey = TelegramHomepageShortcutsFindManyQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramHomepageShortcutsControllerFindManyQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? telegramHomepageShortcutsFindManyQueryKey();

  const query = useQuery(
    {
      ...telegramHomepageShortcutsFindManyQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
